import React, { Fragment } from "react";
import { _O } from "../../../modules/utils";

export default (props) => {
    const {allimData, deleteAlrm, goToUrl} = props;
    let title;
    let msgData1 = allimData.alrmMsg;
    let msgData2;
    let url;
    let fullMsg;
    let btnTitle;

    if (allimData.alrmType === "BP") {
      title = "복약알림";
      btnTitle = "복약입력 바로가기";
      msgData2 = "혈압약";
    } else if (allimData.alrmType === "BS") {
      title = "복약알림";
      btnTitle = "복약입력 바로가기";
      msgData2 = "당뇨약";
    } else if (allimData.alrmType === "HR") {
      title = "병원알림";
      btnTitle = "예약현황 바로가기";
      if (allimData.keyVal === "1") {
        msgData2 = "방문";
      } else {
        msgData2 = "전화";
      }
    } else if (allimData.alrmType === "EP") {
      title = "병원알림";
      btnTitle = "처방전 바로가기";
      msgData2 = allimData.keyVal;
    } else if (allimData.alrmType === "PM") {
      title = "약국알림";
      btnTitle = "약국접수 바로가기";
      msgData2 = allimData.keyVal;
    } else if (allimData.alrmType === "PT") {
      title = "병원알림";
      // btnTitle = "최근파일함 바로가기";
      btnTitle = "개인진료기록 바로가기";

      if (allimData.keyVal == "2") {
        msgData2 = "영상자료";
      } else if (allimData.keyVal == "3") {
        msgData2 = "교육자료";
      } else if (allimData.keyVal == "4") {
        msgData2 = "검사결과";
      } else if (allimData.keyVal == "5") {
        msgData2 = "의무기록";
      } else if (allimData.keyVal == "mirabell_education") {
        btnTitle = "교육자료 바로가기";
        msgData2 = "법정교육";
      } else {
        msgData2 = allimData.keyVal;
      }
    } else if (allimData.alrmType === "PR") {
      title = "병원알림";
      btnTitle = "제증명이력 바로가기";
    }

    if (allimData.alrmType === "BP") {
      url =
        "/sm/bp/medicine/input2/" + allimData.alrmDt + "/" + allimData.alrmType;
    } else if (allimData.alrmType === "BS") {
      url =
        "/sm/bs/medicine/input2/" + allimData.alrmDt + "/" + allimData.alrmType;
    } else if (allimData.alrmType === "HR") {
      url = "/resrvList";
    } else if (allimData.alrmType === "EP") {
      url = "/eocs";
    } else if (allimData.alrmType === "PM") {
      url = "/eocs/history";
    } else if (allimData.alrmType === "PT") {
      // url = "/pmr/recentFileList";
      url = "/pmr/treatmentData";

      if (allimData.keyVal == "mirabell_education") {
        url = "/pmr/treatEducation";
      }
    } else if (allimData.alrmType === "PR") {
      url = "/proof/storage/3/1/1";
    }

    if(allimData.alrmType === "BP" || allimData.alrmType === "BS") {
        if(allimData.column1 === "N") {
            fullMsg = msgData1 + " " + msgData2 + " 복약기록이 체크 되었습니다.";
        } else {
            fullMsg = msgData1 + " " + msgData2 + " 복약 알림이 있습니다." + "<br />" + "복악알림을 확인해주세요";
        }
    } else if(allimData.alrmType === "HR") {
        //병원에서 방문(전화)진료 예정입니다.
        fullMsg = msgData1 + "<br /> [" + msgData2 + "진료]";
    } else if(allimData.alrmType === "EP") {
        fullMsg = msgData1 + "에서 처방전이 (교부번호 : " + msgData2 + ") " + "발행되었습니다.";
    } else if(allimData.alrmType === "PM") {
        fullMsg = msgData1;
    } else if(allimData.alrmType === "PT") {
        fullMsg = msgData1 + "에서 개인진료기록(" + msgData2 + ")이 전송되었습니다."; 
    } else if(allimData.alrmType === "PR") {
        fullMsg = msgData1 + "에서 제증명서류가 전송되었습니다."; 
    }

    return(
        <div className="wh-box">
            <a className="btn_closex" onClick={()=>deleteAlrm("알림삭제", "알림을 삭제하겠습니까?", allimData.alrmNo)}></a>
            <b>{title}</b> {allimData.date1} {allimData.date2} {allimData.date3}
            <p dangerouslySetInnerHTML = {{__html: fullMsg}} />
            {(allimData.alrmType === "BS" || allimData.alrmType === "BP") && allimData.column1 === "N"
                ?   <div className="in-chd-box">
                        <span><i></i> 복약 체크완료</span>
                    </div>
                :   <div>
                        <a onClick={()=>goToUrl(allimData.alrmNo, url, allimData.alrmType)} className={allimData.date1 === "오늘" ? "btn-pp-go" : "btn-pin-go"}><i></i> {btnTitle}</a>
                    </div>
            }
            
        </div>
    );
}